<div class="d-flex w-100 justify-content-between">
    <h2 mat-dialog-title>
        Wijzig aantal {{data.type.name}}
    </h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="pb-0">
    <div class="d-flex">
        <div class="pe-2">
            <button class="mt-2" mat-flat-button color="primary" (click)="fcAmount.setValue(fcAmount.value > minAmount ? (fcAmount.value - 1) : 1)">
                <mat-icon class="m-0 fa-solid fa-minus"></mat-icon>
            </button>
        </div>
        <mat-form-field class="amount-control" color="accent">
            <input [formControl]="fcAmount"
                   matInput
                   appDecimalInput
                   [decimalInput]="0"
                   autocomplete="one-time-code"
                   placeholder="Aantal"
                   type="text">
            <mat-label>Aantal</mat-label>
            <mat-error [control]="fcAmount"></mat-error>
        </mat-form-field>
        <div class="ps-2">
            <button class="mt-2" mat-flat-button color="primary"
                    (click)="fcAmount.setValue(fcAmount.value < maxAmount ? (fcAmount.value + 1) : fcAmount.value)">
                <mat-icon class="m-0 fa-solid fa-plus"></mat-icon>
            </button>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-between">
    <button mat-flat-button mat-dialog-close>Sluiten</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="fcAmount.invalid" cdkFocusInitial>Opslaan</button>
</mat-dialog-actions>
